import React from 'react'
import '../../App.css';
import './WorkContent.css';

function EcoResort() {
    window.scrollTo(0, 0)
    return (
        <div className='container'>
        <h1>Arraial D'Ajuda Eco Resort Website</h1>
        <section>
            <div className="banner-ecoresort">
            </div>
        </section>

        <div className='text'>
            <p>Website layout concept for a hotel</p>
            <p> For additional information about this project please visit:</p>
            <p><a href="https://www.figma.com/file/oJdReXcu4nlfHrgociDfzX/Eco-Resort" target="_blank">Full layout on Figma</a></p>
        </div>
    </div>
    );
}

export default EcoResort
